import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { Calendar, ArrowRight } from "lucide-react";

export function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="blog-page" className="container-max px-4 md:px-8 section-pad">
      <div className="overline mb-3">Blog</div>
      <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tighter mb-10">Lezzet ve Tazelik Üzerine</h1>
      <div className="grid md:grid-cols-3 gap-7">
        {posts.map((p) => (
          <Link to={`/blog/${p.slug}`} key={p.id} data-testid={`blog-${p.slug}`} className="bg-white rounded-2xl overflow-hidden border border-slate-100 hover:-translate-y-1 hover:shadow-lg transition-all">
            <div className="aspect-video overflow-hidden">
              <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-6">
              <div className="flex items-center text-xs text-slate-500 mb-2 gap-1.5"><Calendar size={12} /> {new Date(p.created_at).toLocaleDateString("tr-TR")}</div>
              <h3 className="font-display text-xl font-bold mb-2 leading-tight">{p.title}</h3>
              <p className="text-slate-600 text-sm line-clamp-2 mb-3">{p.excerpt}</p>
              <span className="text-[#0077B6] text-sm font-semibold inline-flex items-center gap-1">Devamı <ArrowRight size={13} /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => {}); }, [slug]);
  if (!p) return <div className="section-pad container-max">Yükleniyor...</div>;
  return (
    <article data-testid="blog-post-page" className="container-max max-w-3xl px-4 md:px-8 section-pad">
      <Link to="/blog" className="text-sm text-[#0077B6] mb-6 inline-block">← Tüm yazılar</Link>
      <h1 className="font-display text-3xl md:text-5xl font-extrabold tracking-tighter mb-4">{p.title}</h1>
      <div className="flex items-center text-sm text-slate-500 mb-6 gap-2"><Calendar size={14} /> {new Date(p.created_at).toLocaleDateString("tr-TR")}</div>
      {p.cover_image && <img src={p.cover_image} alt={p.title} className="rounded-2xl mb-8 aspect-video object-cover w-full" />}
      <div className="prose prose-slate max-w-none text-slate-700 leading-relaxed whitespace-pre-line">{p.content}</div>
    </article>
  );
}
